import { InitialState } from '../state';
import { AppReducer } from './app-reducer';

export const alarmAcknowledgeReducer: AppReducer<'AlarmAcknowledgement'> = (
    state = InitialState.AlarmAcknowledgement,
    action
): typeof state => {
    switch (action.type) {
        case 'AlarmAcknowledgement/Load/Started':
            return {
                loading: true,
                success: false,
                statusCode: 0,
                status: '',
                acknowledgeUser: '',
                acknowledgeTime: '',
            };
        case 'AlarmAcknowledgement/Load/Succeeded':
            return {
                loading: false,
                success: true,
                statusCode: action.payload.statusCode,
                status: action.payload.status,
                acknowledgeUser: action.payload.acknowledgeUser,
                acknowledgeTime: action.payload.acknowledgeTime,
            };
        case 'AlarmAcknowledgement/Load/Failed':
            return {
                loading: false,
                success: false,
                statusCode: action.payload.statusCode,
                status: '',
                acknowledgeUser: '',
                acknowledgeTime: '',
            };
        case 'AlarmAcknowledgement/Load/Unmounted':
            return {
                loading: false,
                success: false,
                statusCode: 0,
                status: '',
                acknowledgeUser: '',
                acknowledgeTime: '',
            };
        default:
            return state;
    }
};
